( function ( _s ) {
	/**
	 * holds the index of the
	 */
	let EventsNewsResourcesCurrentIndex = 0;
	let TeamMemberCurrentIndex = 0;

	const queryElementsAndApplyImages = () => {
		//Events
		if (
			window.fr_vars.event_card_placeholder_images &&
			window.fr_vars.event_card_placeholder_images.length
		) {
			applyImages(
				window.fr_vars.event_card_placeholder_images,
				_s(
					'.card:not(.fr-initialized-placeholder-images):has(.card-image-container.no-img)'
				).filter( '.card-post-type-event, .card-post-type-news-resource' ).el,
				'.card-image-container',
				EventsNewsResourcesCurrentIndex
			);
		}

		//team members
		if (
			window.fr_vars.team_member_card_placeholder_images &&
			window.fr_vars.team_member_card_placeholder_images.length
		) {
			applyImages(
				window.fr_vars.team_member_card_placeholder_images,
				_s(
					'.card:not(.fr-initialized-placeholder-images):has(.card-image-container.no-img)'
				).filter( '.card-post-type-team-member' ).el,
				'.card-image-container',
				TeamMemberCurrentIndex
			);
		}
	};

	const applyImages = ( imagesArray, elements, cardImageContainerSelector, currentIndex ) => {
		_s( elements ).each( iEl => {
			const _el = _s( iEl );

			_el.find( cardImageContainerSelector )
				.css( 'background-image', `url(${ imagesArray[ currentIndex ] })` )
				.css( 'background-size', 'cover' )
				.css( 'background-position', 'center' );

			//add initialized class
			_el.addClass( 'fr-initialized-placeholder-images' );

			//cycle the index
			currentIndex = currentIndex >= imagesArray.length - 1 ? 0 : currentIndex + 1;
		} );
	};

	const observeCards = () => {
		const observer = new MutationObserver( mutations => {
			//for elements on page load
			queryElementsAndApplyImages();

			//for elements added dynamically
			mutations.forEach( mutation => {
				if ( mutation.type === 'childList' ) {
					mutation.addedNodes.forEach( node => {
						if ( node.nodeType === Node.ELEMENT_NODE ) {
							queryElementsAndApplyImages();
						}
					} );
				}
			} );
		} );

		// Observe the entire document body for changes
		observer.observe( document.body, { childList: true, subtree: true } );
	};

	// Call the function to start observing if there is data for these
	if (
		window.fr_vars.event_card_placeholder_images ||
		window.fr_vars.team_member_card_placeholder_images
	) {
		observeCards();
	}
} )( window._s );
